import { createClient } from '@supabase/supabase-js';
const supabaseUrl = 'https://yrcfwfrejpzvafteucff.supabase.co';
const supabaseAnonKey = 'sb_publishable_lKwxMayQJvJDB5NhO3W8Fw_fc2Ww-Fw';
export const supabase = createClient(supabaseUrl, supabaseAnonKey);